import { ModuleUtils } from "../../utils/moduleutils";
import { formSubmitDirective } from './formsubmit.directive';

const moduleOptions: ngExtendedType.IModuleOptions = {
	injectModules: [],
	name: "Directives.Module",
	directives: { formSubmitDirective }
};

export let DirectiveModule = ModuleUtils.CreateModule(moduleOptions);